(() => {
    class Aside extends App.Component {
        constructor(container) {
            super(container);
            this.bind();
            this.update();
        }

        get active() {
            return this.container.classList.contains('active');
        }
        set active(active) {
            if (active) {
                App.Interface.Mask.fullscreen().show();
                this.container.classList.add('active');
            } else {
                if (App.Interface.Mask.active) App.Interface.Mask.hide();
                this.container.classList.remove('active');
            }
        }

        bind() {
            /* Globally show aside */
            $(document).on('click', '.js-aside-toggle', e => this.active = !this.active);
            /* Hide aside when mask hides */
            App.Interface.Mask.onHide(Mask => this.active = false);
        }

        update() {
            this.container.style.display = '';
        }
    }
    App.Components.register('aside', Aside);
})();
